export function reachGoal() {
  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    window.yaCounter.reachGoal.apply(window.yaCounter, arguments)
  }
}
